import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import z from 'zod'
import { FeatureIframe } from '@/features/iframes/feature-iframe'

export const Route = createFileRoute('/_app/account-verification_/flow')({
  component: RouteComponent,
  validateSearch: zodValidator(
    z.object({
      url: z.string(),
    }),
  ),
})

function RouteComponent() {
  const { url } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <div className="h-screen">
      {/* Permission for the iframe taken directly from PAY team */}
      <FeatureIframe
        allow="camera *;fullscreen *;accelerometer *;gyroscope *;magnetometer *"
        allowFullScreen
        onExit={() => {
          void navigate({
            to: '/account-verification',
          })
        }}
        url={url}
      />
    </div>
  )
}
